module.exports = __webpack_public_path__ + "static/img/articlehub1.9d85053.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlehub1.jpg
// module id = LLV2
// module chunks = 1